export class NavigationGeoConfirmation {
  constructor(popup) {
    this.searchPopup = popup;

    this.nodes = {
      popup: document.querySelector('[data-geo-confirmation="popup"]'),
      approveCity: document.querySelector('[data-geo-confirmation="approve-city"]'),
      updateCity: document.querySelector('[data-geo-confirmation="update-city"]'),
    };

    this.openPopup();
    this.attachListeners();
  }

  openPopup = () => {
    this.nodes.popup.classList.add('-open');
  };

  closePopup = () => {
    this.nodes.popup.classList.remove('-open');
  };

  attachListeners = () => {
    this.nodes.approveCity.addEventListener('click', this.approveCity);

    this.nodes.updateCity.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closePopup();
      this.searchPopup.open();
    });
  };

  approveCity = () => {
    const { param_name, param_value } = window.userGeolocation;
    this.nodes.approveCity.disabled = true;

    fetch('/api/set-geo-cookies', {
      method: 'post',
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': window.csrf,
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        [param_name]: param_value,
      }),
    })
      .then(() => {
        this.nodes.approveCity.disabled = false;
        this.closePopup();
      })
      .catch((error) => {
        this.nodes.approveCity.disabled = false;
        console.warn(error);
      });
  };
}
